export const de = {
  'ui2-datepicker': {}
};
